export const isExternalURL = (url) =>
  (url.startsWith('http://') || url.startsWith('https://')) &&
  new URL(url).origin !== window.location.origin;
